import request from '@/router/axios';
const urlPrefix = process.env.VUE_APP_LOCAL_DEVELOPMENT == 'true' ? '/wage' : '/wage'


// 获取文件列表
export function getFileList(params) {
  return request({
    url: urlPrefix + '/seagate/financeReport/fileList',
    method: 'post',
    data: params
  });
}

export function downloadFile(data) {
  return request({
    url: urlPrefix+ '/seagate/financeReport/downloadFile',
    method: 'get',
    params: data,
    responseType: 'arraybuffer'
  })
}


// 删除附件
export function deleteAttach(data) {
  return request({
    url: urlPrefix + '/seagate/financeReport/delAttach',
    method: 'get',
    params: data
  });
}

// 上传附件
export function saveAttach(data) {
  return request({
    url: urlPrefix + '/seagate/financeReport/saveAttach',
    method: 'post',
    data: data,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
}
